'use client';
import useNavigator from '@shared/utils/hooks/useNavigator';
import { Loader2 } from 'lucide-react';
import { useRouter } from 'next/navigation';

type Props = {
  error?: unknown;
  loading?: boolean;
  message?: string;
};

const Error = ({ error, loading, message }: Props) => {
  const router = useRouter();
  const { navigatorState } = useNavigator();

  if (!error && !loading) return null;

  return (
    <div className="flex w-full flex-col items-center justify-center text-textSecondary/70">
      {!!error && (
        <>
          <p className="text-center">
            {navigatorState.isOnline
              ? (message ??
                'An error occurred while processing your request. Please refresh the page.')
              : 'You are offline. Try to refresh your connection.'}
          </p>
          {navigatorState.isOnline ? (
            <button className="mt-2.5" onClick={router.refresh}>
              Refresh
            </button>
          ) : (
            <p className="mt-2.5">Network Error</p>
          )}
        </>
      )}
      {loading && !error && (
        <Loader2 className="animate-spin" height={60} width={60} />
      )}
    </div>
  );
};

export default Error;
